import { Features } from "./scripts/FeatureCheck";
export var AppFlag = Features.ACDRIVE;